import { FC, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoginForm, LoginFormStep, OuterPage } from '../components';
import { AuthContext } from '../components';
import { RoutePath } from '../config';

export const LoginPage: FC = () => {
  const [subtitle, setSubtitle] = useState('login:subtitle');

  const { isAuthorized } = useContext(AuthContext);

  const location = useLocation();
  const navigate = useNavigate();

  const nextUrl = useMemo(() => {
    const qs = new URLSearchParams(location.search);
    return qs.get('next');
  }, [location.search]);

  useEffect(() => {
    if (!isAuthorized) return;

    if (nextUrl) {
      navigate(nextUrl, { replace: true });
    } else {
      navigate(RoutePath.Profile, { replace: true });
    }
  }, [isAuthorized, nextUrl, navigate]);

  const onChangeStep = useCallback((step: LoginFormStep) => {
    setSubtitle(step === 'membershipId' ? 'login:subtitle' : 'login:subtitle_2');
  }, []);

  return (
    <OuterPage isBackVisible title="login:title" subtitle={subtitle}>
      <LoginForm onChangeStep={onChangeStep} />
    </OuterPage>
  );
};